import React from 'react';
import { WHATSAPP_DISPLAY, whatsappLink } from '../utils/whatsapp';
export function Footer() {
  return <footer className="bg-ink px-5 py-10 lg:px-8" data-id="element-65" data-mp="3gfiswe27a3c0">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 text-center" data-id="element-66" data-mp="3ghc0bvkn0rl2">
        <p className="font-display text-lg uppercase tracking-[0.3em] text-gold" data-id="element-67" data-mp="32pp3nums9h1r">
          Dr. Solución
        </p>
        <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="text-sm text-white/70 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-68" data-mp="36n3axgqwler4">
          WhatsApp {WHATSAPP_DISPLAY}
        </a>
        <p className="max-w-xl text-xs leading-relaxed text-white/40" data-id="element-69" data-mp="3ldu34pweqfur">
          Consultas espirituales. Los resultados pueden variar según cada
          persona y su fe. Servicio para mayores de 18 años.
        </p>
      </div>
    </footer>;
}